import { lazy } from "react";

const Login = lazy(() => import("../views/auth/Login"));
const PasswordReset = lazy(() => import("../views/auth/PasswordReset"));
const Error = lazy(() => import("../views/Error"));

export const publicRoutes = [
  {
    path: "/login",
    element: <Login />,
    meta: {
      layout: "blank",
    },
  },
  {
    path: "/password-reset",
    element: <PasswordReset />,
    meta: {
      layout: "blank",
    },
  },
  {
    path: "/error",
    element: <Error />,
    meta: {
      layout: "blank",
    },
  },
  {
    path: "/*",
    element: <Error />,
    meta: {
      layout: "blank",
    },
  },
];
